// « Nouveau » tant qu'une cible a moins de 5 avis (même règle que les apps natives ; seuil serveur review_min_count_display).
export const MIN_REVIEWS_DISPLAY = 5;
export function ratingText(rating, count) {
  if (count != null) return Number(count) < MIN_REVIEWS_DISPLAY ? 'Nouveau' : Number(rating ?? 5).toFixed(1);
  return typeof rating === 'number' ? rating.toFixed(1) : 'Nouveau';
}
